export const PRIMARY_COLOR = '#215F69';
